import { createFileRoute } from '@tanstack/react-router';
import { RulesPage } from '@/features/prestation-rules/components/RulesPage';

export const Route = createFileRoute('/$commiteeSlug/prestation-rules/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <RulesPage />;
}
